import { useParams } from "react-router-dom";
import { useEffect } from "react";
import AtomAssistPageLoad from "src/views/assistant/components/AtomAssistPageLoad";
import { useChatStore } from "src/views/assistant/stores/ChatStore";
import { useSetWorkflowProductConfig } from "src/views/products/workflow/hooks/useWorkflowProductConfig";
import { FIFTY_FIFTY_NINE_PRODUCT } from "./fiftyFiftyNineProduct";
import { useFfnStore } from "./store/FfnStore";
import FfnChat from "./FfnChat";

const FfnChatPage = () => {
  const { dialogueId: dialogueIdParam } = useParams<{ dialogueId: string }>();
  const dialogueId = dialogueIdParam ? Number(dialogueIdParam) : undefined;

  // Set by the splash kickoff; fired by useStartChatOnMount inside FfnChat.
  const { initialUserMessage } = useChatStore();

  useEffect(() => {
    if (dialogueId) {
      useFfnStore.setState({ dialogueId });
    }
  }, [dialogueId]);

  useSetWorkflowProductConfig(FIFTY_FIFTY_NINE_PRODUCT);

  if (!dialogueId) {
    return <AtomAssistPageLoad />;
  }

  return (
    <FfnChat dialogueId={dialogueId} initialUserMessage={initialUserMessage} />
  );
};

export default FfnChatPage;
